import {makeAutoObservable} from "mobx";
import axios from "axios";

export default class TableauBlancStore {
    constructor() {
        this.view = "Lecture";
        this.idWidget = "";
        this.isLoading = true;
        this._token = null;
        this.tb_nom = "";
        this.listeCanvas = [];
        this.idCanvas = null;
        this.canvaEpingle = null;
        this.hasBibliothequeImages = false;
        this.lastError = "";
        this.clientId = window.sessionStorage.getItem('seizo_tableau_blanc_client_id')
            || `${Date.now()}-${Math.random().toString(36).slice(2)}`;

        window.sessionStorage.setItem('seizo_tableau_blanc_client_id', this.clientId);

        makeAutoObservable(this);
    }

    initialize(token, idWidget) {
        this._token = token;
        this.idWidget = idWidget;
        this.idCanvas = null;
        this.getListeCanvas().catch(() => {});
    }

    requestConfig() {
        return {headers: {'Authorization': 'Bearer ' + this._token}};
    }

    saveError(error) {
        this.lastError = error?.response?.data?.message || "Une erreur est survenue avec le Tableau Blanc.";
        console.error(this.lastError, error);
    }

    async saveCanvas(jsonCanva) {
        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/saveCanvas/" + this.idCanvas,
                {canvasData: jsonCanva, client_id: this.clientId},
                this.requestConfig()
            );
            this.lastError = "";
            return true;
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async saveCanvasAsImage(imageBase64) {
        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/saveImage/" + this.idCanvas,
                {imageData: imageBase64, client_id: this.clientId},
                this.requestConfig()
            );
            this.lastError = "";
            return true;
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async loadCanvas(idCanva = this.idCanvas) {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/loadCanvas/" + idCanva,
                this.requestConfig()
            );
            this.lastError = "";
            return response.data;
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async getListeCanvas() {
        this.isLoading = true;
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + this.idWidget + "/liste-canvas",
                this.requestConfig()
            );
            this.tb_nom = response.data.tb_nom;
            this.canvaEpingle = response.data.canvaEpingle;
            this.listeCanvas = response.data.listeCanvas;
            this.lastError = "";
            return response.data;
        } catch (error) {
            this.listeCanvas = [];
            this.saveError(error);
            throw error;
        } finally {
            this.isLoading = false;
        }
    }

    async createCanvas() {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + this.idWidget + "/create-canvas",
                {},
                this.requestConfig()
            );
            this.idCanvas = response.data.id_canva;
            await this.getListeCanvas();
            return response.data;
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async renameCanvas(idCanva, newName) {
        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + idCanva + "/rename-canvas",
                {canva_nom: newName},
                this.requestConfig()
            );
            await this.getListeCanvas();
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async epinglerCanvas(idCanva) {
        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + idCanva + "/epingle-canvas",
                {},
                this.requestConfig()
            );
            await this.getListeCanvas();
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async deleteCanvas(idCanva) {
        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + idCanva + "/delete-canvas",
                {},
                this.requestConfig()
            );
            await this.getListeCanvas();
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async dupliquerCanvas(idCanva) {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + idCanva + "/dupliquer-canvas",
                {},
                this.requestConfig()
            );
            await this.getListeCanvas();
            return response.data;
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }

    async createPlanningAction(payload) {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/tableauBlanc/" + this.idCanvas + "/planning-actions",
                payload,
                this.requestConfig()
            );
            this.lastError = "";
            return response.data;
        } catch (error) {
            this.saveError(error);
            throw error;
        }
    }
}
